import React from "react";
import { ReactDOM } from "react";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Register from "./components/Register";
import CountdownTimer from "./components/CountdownTimer";
import Schedule from "./components/Schedule";
import Welcome from "./components/Welcome";
import About from "./components/About";
import Place from "./components/Place";
import MovingBg from "./components/MovingBg";
import Faqs from "./components/Faqs";
import Qr from "./components/Qr";




function App() {
  return (
    <div className="bg-gradient-to-r from-[#222e36] to-[#031828] h-screen text-[#86c232] overflow-auto justify-center ">
    <MovingBg/>
     <Header/>
     <Welcome/>
     <About/>
     <Place/>
     <Schedule/>
     <Faqs/>
     <CountdownTimer/>
     <Qr/>
     <Register/>
     <Footer/>
    </div>
  );
}

export default App;
